import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/App";
import { useTranslation } from "@/i18n/translations";

const ICONS = { channel: "📡", branch: "🏢", phone: "📞" };

export default function ActiveAddonsList({ items, onChanged }) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState("");
  if (!items?.length) return null;

  const act = async (id, action) => {
    if (action === "cancel" && !window.confirm(t("addons.cancelConfirm"))) return;
    setBusy(id);
    try {
      await axios.post(`${API}/billing/addon/${id}/${action}`);
      toast.success(action === "cancel" ? t("addons.cancelled") : t("addons.resumed"));
      onChanged?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Error");
    } finally {
      setBusy("");
    }
  };

  const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString() : "");

  return (
    <div className="mt-5 border-t-2 border-gray-200 pt-4" data-testid="active-addons-list">
      <div className="text-sm font-bold mb-2">{t("addons.yours")}</div>
      <div className="space-y-2">
        {items.map((a) => (
          <div key={a.id} className="flex flex-wrap items-center gap-3 text-sm p-3 rounded-lg bg-gray-50 border border-gray-200" data-testid={`addon-item-${a.type}`}>
            <span className="font-semibold">{ICONS[a.type]} {t(`addons.${a.type}`)}{a.qty > 1 ? ` ×${a.qty}` : ""}</span>
            <span className="text-xs text-gray-600 flex-1">
              {a.recurring
                ? (a.cancel_at ? t("addons.endsOn", { date: fmt(a.cancel_at) }) : `€${Number(a.unit_price || 0).toFixed(2)}/${t("addons.mo")} · ${t("addons.autoRenew")}`)
                : t("addons.validUntil", { date: fmt(a.valid_until) })}
            </span>
            {a.recurring && !a.cancel_at && (
              <button type="button" onClick={() => act(a.id, "cancel")} disabled={busy === a.id} data-testid={`addon-cancel-${a.type}`}
                className="text-xs font-semibold underline text-gray-700 hover:text-black disabled:opacity-50">{t("addons.cancel")}</button>
            )}
            {a.recurring && a.cancel_at && (
              <button type="button" onClick={() => act(a.id, "resume")} disabled={busy === a.id} data-testid={`addon-resume-${a.type}`}
                className="text-xs font-semibold underline text-green-700 disabled:opacity-50">{t("addons.resume")}</button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
